import React, {useMemo, useState} from "react";
import {FormattedMessage} from 'react-intl';
import Search, {SearchInputType} from '@components/custom/Search';
import moment from 'moment';
import {SelectionMode, IntervalOptions, Interval} from '@models/index';
import DiscountCodePolicysSelection from "../../discountCodePolicy/Selection"
import __i18n from "../../../intl/__i18n";


interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
  intl: any;
}

const SubscriptionsReportSearch: React.FC<SearchInputProps> = props => {
  const {search} = props;
  
  
  const inputs = [{
    name: "discount_code_policy_id",
    label: __i18n("Discount Code Policy"),
    component: DiscountCodePolicysSelection,
    size: 12,
    type: SearchInputType.SELECT,
    InputProps: {
      mode: SelectionMode.DEFAULT,
    }
  },{
    name: "unique_identifier",
    label: __i18n("Unique Identifier"),
    type: SearchInputType.TEXT,
    size: 12,
  }];
  
  return(
    <Search
      inputs={inputs}
      search={search}
      hasClearButton={true}
      searchOnChange={false}/>
  )
};


export default SubscriptionsReportSearch;